// Session id shim.
//
// SEC-002: the AUTHORITATIVE session id is now server-minted and lives
// in an httpOnly cookie (`codex_sid`) that the browser sends
// automatically. The value cached in localStorage is DISPLAY-ONLY —
// used so the UI can render a stable label between reloads while the
// real cookie does the actual history-binding on the server.
const SESSION_KEY = "njc_session_id";

export function ensureSession() {
    let s = localStorage.getItem(SESSION_KEY);
    if (!s) {
        // Placeholder only. Backend ignores this value and uses the
        // httpOnly cookie for all history reads. Keeping a local
        // placeholder avoids UI churn on first paint before the first
        // backend response echoes the real session id.
        s = `s_${Date.now()}_${Math.floor(Math.random() * 999999)}`;
        localStorage.setItem(SESSION_KEY, s);
    }
    return s;
}

export function clearSession() {
    localStorage.removeItem(SESSION_KEY);
}

// Called after every backend response that echoes back a `session_id`
// field. Keeps the local display value in sync with the server-minted
// cookie session id so the UI shows the same value the server actually
// uses for history binding.
export function syncServerSession(serverSessionId) {
    if (typeof serverSessionId === "string" && serverSessionId.length >= 20) {
        localStorage.setItem(SESSION_KEY, serverSessionId);
    }
}
